import { Controller } from "@hotwired/stimulus"

// Zeigt initial nur die ersten N Listenelemente (Targets "item") an.
// Per Button (Target "button") kann zwischen "mehr anzeigen" und "weniger anzeigen" umgeschaltet werden.
export default class extends Controller {
  static targets = ["item", "button"]
  static values = {
    limit: { type: Number, default: 1 },
    expanded: { type: Boolean, default: false },
    moreText: { type: String, default: "mehr anzeigen" },
    lessText: { type: String, default: "weniger anzeigen" }
  }

  connect() {
    this.update()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.update()
  }

  update() {
    const visibleUntil = this.limitValue
    this.itemTargets.forEach((el, index) => {
      if (this.expandedValue) {
        el.classList.remove("hidden")
      } else {
        if (index < visibleUntil) {
          el.classList.remove("hidden")
        } else {
          el.classList.add("hidden")
        }
      }
    })

    // Button-Text und Sichtbarkeit
    if (this.itemTargets.length <= visibleUntil) {
      if (this.hasButtonTarget) this.buttonTarget.classList.add("hidden")
    } else {
      if (this.hasButtonTarget) {
        this.buttonTarget.classList.remove("hidden")
        this.buttonTarget.textContent = this.expandedValue ? this.lessTextValue : this.moreTextValue
      }
    }
  }
}

